/**
 * Delivery Estimate Message
 */
import React, { forwardRef } from "react";
import { omit } from "lodash-es";
import { Alert, Box, Heading, IconDeliveryTruck, Text, } from "@catchoftheday/cg-components";
export const DeliveryEstimateMessage = forwardRef((props, ref) => {
    const label = "deliveryEstimate" in props ? props.deliveryEstimate.label : props.label;
    const description = "deliveryEstimate" in props
        ? props.deliveryEstimate.labelType === "Estimated"
            ? props.deliveryEstimate.labelDescription
            : ""
        : props.description;
    const alertProps = omit(props, ["deliveryEstimate", "label"]);
    return (<Box ref={ref} borderRadius={4} overflow="hidden">
      <Alert type="inline" icon={<IconDeliveryTruck height={24} width={24}/>} alignIcon="flex-start" variant="info" flexDirection="column" alignItems="flex-start" {...alertProps}>
        <Heading.h5 m={0}>{label}</Heading.h5>
        {description && (<Text fontSize="xs" m={0}>
            {description}
          </Text>)}
      </Alert>
    </Box>);
});
DeliveryEstimateMessage.displayName = "DeliveryEstimateMessage";
